import React, { ReactNode } from "react";
import { withRouter } from "react-router-dom";

import { ISessionUser } from "@/data/session";
import { IWithRouteMatchProps } from "@/infrastructure/Route";
import { IWithSessionProps, withSession } from "@/infrastructure/Session";
import { router } from "@/views/router";

interface IRenderProps {
  isAuthenticated: boolean;
}

interface Props extends IWithSessionProps<ISessionUser>, IWithRouteMatchProps {
  children: (props: IRenderProps) => ReactNode;
}

class LoginRequiredComponent extends React.PureComponent<Props> {
  constructor(props: Props) {
    super(props);
    this.checkSession();
  }

  checkSession() {
    const {
      session: { authenticated, pristine },
      location: { pathname },
    } = this.props;

    if (!authenticated && !pristine && /^\/app/.test(pathname)) {
      this.goToLogin();
    }
  }

  goToLogin = () => {
    const { history, location } = this.props;

    history.replace(router.get("login").path, { redirect: location.pathname + location.search });

    localStorage.setItem("redirectUrl", location.pathname + location.search);
  };

  render() {
    const {
      children,
      session: { authenticated },
    } = this.props;

    return children({ isAuthenticated: authenticated });
  }
}

export const LoginRequired = withRouter(withSession(LoginRequiredComponent));
